import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import classNames from "classnames";
import "./index.scss";

import { isEmpty } from "../../../utils/objects-util";
import { createAction } from "../../../utils/sagaHelper";
import { TYPE_EDIT_ACTION } from "../../../utils/enums";

import IconButton from "../IconButton";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";
import { toast } from 'react-toastify';

const SectionItemArrayItems = ({
    t,
    item,
    value, 
    column,
    onPropChange,
    itemAction
}) => {
    const [newValue, setNewValue] = useState("");

    const handleOnAdd = () => {
        return new Promise((resolve, reject)=> {
            const num = column.isNumber ? parseInt(newValue) : newValue;

            if(value.length >= column.maxItems) {
                resolve();
                toast(`You can add only ${column.maxItems} items.`);
                return;
            }

            if((column.isNumber && !isNaN(num)) || !isEmpty(newValue)) {                
                if(!value.find(f=> f === value)) {
                    resolve();

                    if(column.actionName) {
                        itemAction(column.actionName, { 
                            item:  { ...item, [column.accessor]: value.concat(num) },
                            type: TYPE_EDIT_ACTION.add,
                            accessor: column.accessor,
                            value: num
                        });
                    } else {
                        onPropChange({ [column.accessor]: value.concat(num) });
                    }
                } else {
                    reject();
                }              
                
                setNewValue("");
            } else {
                reject();
            }            
        });
    }

    const handleOnRemove = index => {
        return new Promise(resolve=> {
            resolve();
            if(!column.isReadonly){
                if(column.actionName) {
                    itemAction(column.actionName, { 
                        item:  { ...item, [column.accessor]: value.filter((f, i)=> i !== index) },
                        type: TYPE_EDIT_ACTION.delete,
                        accessor: column.accessor,
                        value: index
                    });
                } else {
                    onPropChange({ [column.accessor]: value.filter((f, i)=> i !== index) });
                }
            }
        });
    }

    const handleOnEdit = (e, index) => {
        if(column.isReadonly){
            return;
        }

        const val = column.isNumber ? parseInt(e.currentTarget.value) : e.currentTarget.value;

        if(column.actionName) {
            itemAction(column.actionName, { 
                item:  { 
                    ...item, 
                    [column.accessor]: value.map((listItem, listItemIndex) => listItemIndex === index ? val : listItem) 
                },
                type: TYPE_EDIT_ACTION.edit,
                accessor: column.accessor,
                value: val
            });
        } else {
            onPropChange({
                [column.accessor]: value.map((listItem, listItemIndex) => listItemIndex === index ? val : listItem)
            });
        }
    }

    const handleOnChangeNewValue = e => {
        setNewValue(e.currentTarget.value);
    }

    return (
        <div className={classNames("sectionItemArrayItems", { numeric: column.isNumber })}>
            <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
            <div className={classNames("arrayItemsAddBlock")}>
                <input type="text" value={newValue} 
                    className={classNames("sectionItemArrayItemValue")}
                    onChange={handleOnChangeNewValue}
                />
                {!!column.measure && (
                    <span className="arrayItemsMeasure">{column.measure}</span>
                )}
                <span className={"addNewValue"} onClick={handleOnAdd}>{t("basic.ADD_BUTTON")}</span>
            </div>
            <div className={"sectionItemArrayItemsData"}>
                {(value || []).map((val, index) => (
                    <div key={`sectionItemArrayItem-${index}`} className={classNames("sectionItemArrayItem")}>
                        <input type="text" value={val} className={classNames("sectionItemArrayItemValue")}
                               onChange={e=> handleOnEdit(e, index)}
                        />
                        <IconButton isIcon={true}
                                    iconName={"orderDelete"}
                                    tooltipText={column.deleteTooltip || t("basic.DELETE_BUTTON")}
                                    onClick={()=> handleOnRemove(index)}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        itemAction: (action, data) => dispatch(createAction(action, data))
    };
};

export default connect(null, mapDispatchToProps)(withTranslation()(SectionItemArrayItems));